module.exports = __webpack_public_path__ + "img/btn-armchair@2x.b09cd576.png";